// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"11b286e1","825":"11b286e1"}[chunkId] + ".chunk.css";
};